import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IGk } from '../../store/pik_data/gks';

export enum EGksActionTypes {
  SetGks = 'GKS/SET',
}

export type TSetGks = ITypedReduxAction<EGksActionTypes.SetGks, IGk[]>;

export const setGks: (gks: IGk[]) => TSetGks = actionGenerator<EGksActionTypes.SetGks, IGk[]>(EGksActionTypes.SetGks);
